import make, { Enum } from '@xaamin/enum';

class SocioDeNegocioStatus extends Enum {

  name = 'SocioDeNegocioStatus';

  enum = {
    'pending': 0,
    'active': 1,
    'blocked': -1,
    'undefined': 33,
  }

}

export default make(SocioDeNegocioStatus);